import Axios from "axios";
import {
  SET_PRODUCTION_QC_LIST,
  UNSET_PRODUCTION_QC_LIST,
  SET_PRODUCTION_QC_INLINE_LIST,
  UNSET_PRODUCTION_QC_INLINE_LIST,
  SET_PRODUCTION_QC_FINAL_LIST,
  UNSET_PRODUCTION_QC_FINAL_LIST,
} from "@/store/mutation-types";
import { 
  qcInlineResource, 
  qcFinalResource,
  qcResource,
} from "@/store/api";

// Initial State
const state = {
  getProductionQcList: [],
  getProductionQcInlineList: [],
  getProductionQcFinalList: [],
};

// Getters
const getters = {
  getProductionQcList(state) {
    return state.getProductionQcList;
  },
  getProductionQcInlineList(state) {
    return state.getProductionQcInlineList;
  },
  getProductionQcFinalList(state) {
    return state.getProductionQcFinalList;
  },
};

// Mutations
const mutations = {
  [SET_PRODUCTION_QC_LIST](state, data) {
    state.getProductionQcList = data;
  },
  [UNSET_PRODUCTION_QC_LIST](state) {
    state.getProductionQcList = [];
  },
  [SET_PRODUCTION_QC_INLINE_LIST](state, data) {
    state.getProductionQcInlineList = data;
  },
  [UNSET_PRODUCTION_QC_INLINE_LIST](state) {
    state.getProductionQcInlineList = [];
  },
  [SET_PRODUCTION_QC_FINAL_LIST](state, data) {
    state.getProductionQcFinalList = data;
  },
  [UNSET_PRODUCTION_QC_FINAL_LIST](state) {
    state.getProductionQcFinalList = [];
  },
};

// Actions
const actions = {

  saveProductionQc({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(qcResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  updateProductionQc({ commit }, { id, data }) {
      commit("SET_LOADING", { color: "primary" });

      const url = `${qcResource}/${id}`;

      return new Promise((resolve, reject) => {
      Axios.put(url, data)
          .then((response) => {
          resolve(response);
          })
          .catch((error) => {
          reject(error);
          })
          .finally(() => {
          commit("UNSET_LOADING");
          });
      });
  },


  getProductionQcList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(qcResource)
        .then((response) => {
          commit(SET_PRODUCTION_QC_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PRODUCTION_QC_LIST);
          reject(error);
        });
    });
  },

  getProductionQcById({ commit }, { id }) {
      commit("SET_LOADING", { color: "primary" });

      const url = `${qcResource}/${id}`;

      return new Promise((resolve, reject) => {
      Axios.get(url)
          .then((response) => {
          resolve(response);
          })
          .catch((error) => {
          reject(error);
          })
          .finally(() => {
          commit("UNSET_LOADING");
          });
      });
  },
  // QC INLINE
  saveProductionQcInline({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(qcInlineResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  updateProductionQcInline({ commit }, { id, data }) {
      commit("SET_LOADING", { color: "primary" });

      const url = `${qcInlineResource}/${id}`;

      return new Promise((resolve, reject) => {
      Axios.put(url, data)
          .then((response) => {
          resolve(response);
          })
          .catch((error) => {
          reject(error);
          })
          .finally(() => {
          commit("UNSET_LOADING");
          });
      });
  },

  // QC FINAL
  saveProductionQcFinal({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(qcFinalResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};

